export default {
  label: {
    duplicateCardLabel: 'Duplicar',
    filterCardLabel: 'Filtrar',
    resizeCardLabel: 'Redimensionar',
    deleteCardLabel: 'Remover',
    expandCardLabel: 'Expandir',
  },
};
